import React from "react";
import Popup from "../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../Helpers/CloseBtn/Close";
import trans from "../../utils";
import Button from "../Helpers/Button/Button";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function ConfirmationDeletion({ modal, setModal }) {
	const inf = useSelector((state) => state.users.user);

	const deleteAccount = async () => {
		try {
			const response = await axios.delete(
				`${process.env.REACT_APP_BACKEND_URL}/info/delete-account`,
				{
					data: { userId: inf?.id },
				},
			);
			return toast.success(response?.data?.message, {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		} catch (error) {
			if (error.response) {
				console.error(
					"Server error:",
					error.response.status,
					error.response.data,
				);
			} else if (error.request) {
				console.error("Network error:", error.request);
			} else {
				console.error("Request error:", error.message);
			}
			return toast.error(error?.message, {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	return (
		<>
			<Popup show={modal} size="md">
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle headtitle={trans("Delete Account")} />
					</Modal.Title>
					<Close
						style="close-32 close"
						close={() => {
							setModal(false);
						}}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body>
					{trans("Are you sure you want to delete your account?")}{" "}
				</Modal.Body>
				<Modal.Footer>
					<Button
						type={"default"}
						onClick={() => setModal(false)}
						text={trans("Cancel")}
					/>
					<Button
						text={trans("Delete")}
						danger={true}
						onClick={() => deleteAccount()}
					/>
				</Modal.Footer>
			</Popup>
		</>
	);
}